import { MyHttpClient } from '../../app/http-client.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "../http-client.service";
var HostDetailsService = /** @class */ (function () {
    function HostDetailsService(http) {
        this.http = http;
        this.server = "" + environment.server;
        this.getHost = this.server + '/api/getHostByMobile';
    }
    HostDetailsService.prototype.getHostByMobile = function (mobile) {
        return this.http.get(this.getHost + '/' + mobile).pipe(catchError(this.handleError));
    };
    HostDetailsService.prototype.getHostWalletBalance = function (profileId) {
        var url = this.server + "/api/wallet/host/" + profileId + "/walletBalance";
        return this.http.get(url).pipe(catchError(this.handleError));
    };
    HostDetailsService.prototype.getReferralTracking = function (profileId, limit, offset) {
        if (limit === void 0) { limit = 20; }
        if (offset === void 0) { offset = 0; }
        var url = this.server + "/api/pool-manager/profiles/" + profileId + "/referrals/tracking?limit=" + limit + "&offset=" + offset;
        return this.http.get(url).pipe(catchError(this.handleError));
    };
    HostDetailsService.prototype.handleError = function (error) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error("Backend returned code " + error.status + ", " +
                ("body was: " + error.error));
        }
        // return an observable with a user-facing error message
        return throwError(error);
    };
    HostDetailsService.ngInjectableDef = i0.defineInjectable({ factory: function HostDetailsService_Factory() { return new HostDetailsService(i0.inject(i1.MyHttpClient)); }, token: HostDetailsService, providedIn: "root" });
    return HostDetailsService;
}());
export { HostDetailsService };
